<template>
  <div class="search-panel">
    <div class="search-panel__bar">
      <el-input
        v-model="localKeyword"
        class="search-panel__input"
        placeholder="请输入检索词"
        clearable
        @keyup.enter.native="handleSearch"
      />

      <button type="button" class="search-panel__search-btn" @click="handleSearch">
        <i class="el-icon-search" />
      </button>

      <button type="button" class="search-panel__reset-btn" @click="handleReset">
        重置
      </button>
    </div>

    <div v-if="activeTags.length" class="search-panel__tags">
      <el-tag
        v-for="tag in activeTags"
        :key="tag"
        closable
        class="search-panel__tag"
        @close="removeTag(tag)"
      >
        {{ tag }}
      </el-tag>
      <button type="button" class="search-panel__clear-btn" @click="handleClearTags">
        清除
      </button>
    </div>

    <div class="search-panel__toolbar">
      <span class="search-panel__total">共检索到 <em>{{ total }}</em> 条结果</span>
      <div class="search-panel__view-toggle">
        <button
          type="button"
          class="search-panel__view-btn"
          :class="{ 'search-panel__view-btn--active': viewMode === 'list' }"
          aria-label="列表视图"
          @click="$emit('update:viewMode', 'list')"
        >
          <i class="el-icon-s-operation" />
        </button>
        <button
          type="button"
          class="search-panel__view-btn"
          :class="{ 'search-panel__view-btn--active': viewMode === 'grid' }"
          aria-label="网格视图"
          @click="$emit('update:viewMode', 'grid')"
        >
          <i class="el-icon-s-grid" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KnowledgeSearchPanel',
  props: {
    total: {
      type: Number,
      default: 0
    },
    activeTags: {
      type: Array,
      default: () => []
    },
    defaultType: {
      type: String,
      default: ''
    },
    viewMode: {
      type: String,
      default: 'list'
    },
    typeOptions: {
      type: Array,
      default: () => []
    },
    attributeOptions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      localType: this.defaultType,
      localAttribute: '',
      localKeyword: ''
    }
  },
  watch: {
    defaultType(value) {
      if (!this.localType) {
        this.localType = value
      }
    }
  },
  methods: {
    handleTypeChange() {
      this.localAttribute = ''
    },
    handleSearch() {
      this.$emit('search', {
        type: this.localType,
        attribute: this.localAttribute,
        keyword: this.localKeyword.trim()
      })
    },
    handleReset() {
      this.localType = ''
      this.localAttribute = ''
      this.localKeyword = ''
      this.$emit('reset')
    },
    setKeyword(keyword) {
      this.localKeyword = keyword || ''
    },
    removeTag(tag) {
      this.$emit('remove-tag', tag)
    },
    handleClearTags() {
      this.$emit('clear-tags')
    }
  }
}
</script>

<style lang="scss" scoped>
.search-panel {
  background: $color-white;
  border-radius: 4px;
  padding: $spacing-base;
  box-shadow: 0 2px 12px rgba($color-brown-dark, 0.06);

  &__bar {
    display: flex;
    align-items: center;
    gap: $spacing-sm;
    flex-wrap: wrap;
  }

  &__select {
    width: 140px;
    flex-shrink: 0;
  }

  &__input {
    flex: 1;
    min-width: 200px;
  }

  &__search-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 36px;
    background: $color-brown-dark;
    color: $color-white;
    border-radius: 4px;
    font-size: rem(18);
    transition: background 0.2s;
    flex-shrink: 0;

    &:hover {
      background: $primary-color;
    }
  }

  &__reset-btn {
    padding: 0 $spacing-md;
    height: 36px;
    font-size: rem(14);
    color: $color-text-light;
    flex-shrink: 0;

    &:hover {
      color: $color-brown-dark;
    }
  }

  &__tags {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: $spacing-sm;
    margin-top: $spacing-base;
    padding-top: $spacing-base;
    border-top: 1px solid rgba($color-border, 0.5);
  }

  &__tag {
    margin-right: 0;
  }

  &__clear-btn {
    font-size: rem(13);
    color: $success-color;

    &:hover {
      text-decoration: underline;
    }
  }

  &__toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: $spacing-base;
    padding-top: $spacing-base;
    border-top: 1px solid rgba($color-border, 0.5);
  }

  &__total {
    font-size: rem(14);
    color: $color-text-light;

    em {
      font-style: normal;
      font-weight: 600;
      color: $color-brown-dark;
    }
  }

  &__view-toggle {
    display: flex;
    gap: $spacing-xs;
  }

  &__view-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 4px;
    color: $color-text-light;
    font-size: rem(16);
    transition: all 0.2s;

    &:hover {
      background: rgba($color-brown-dark, 0.06);
    }

    &--active {
      background: $color-brown-dark;
      color: $color-white;
    }
  }
}
</style>
